// GENERATED CODE - DO NOT EDIT
// These enum values are lowercased to match common usage.
export const MedSyncStatusMap = {
    // Patient has been detected to be eligible for Med Sync
    ELIGIBLE: 'eligible',
    // Patient is enrolled on Med Sync
    ENROLLED: 'enrolled',
    // Patient has declined Med Sync
    DECLINED: 'declined',
    // Patient has not been responsive to Med Sync outreach
    UNRESPONSIVE: 'unresponsive',
    // Patient is not eligible for Med Sync at the moment
    INELIGIBLE: 'ineligible',
    // Patient has indicated interest in Med Sync but has not confirmed their med list
    INTERESTED: 'interested',
    // Patient has confirmed which medications they want to sync (i.e. their med list) but is not enrolled
    CONFIRMED_MED_LIST: 'confirmed_med_list',
};
//# sourceMappingURL=med_sync_status.js.map